import {
  LOGIN_MODAL_EXPERIMENT,
  LOGIN_MODAL_EXPERIMENT_ID,
  LOGIN_SOURCE_TTU
} from '@cont/Login/constants';
import {
  CURTAIN_TYPE,
  EXPERIMENT_ID,
  EXPERIMENT_NAME,
  VARIATION_NAME
} from '@events/segmentProps';
import useLoginStore from '@stores/login/loginStore';
import {
  getIsLoginModalExperiment,
  getIsLoginModalVariation,
  getIsNewLoginModal
} from '@stores/selectors/login';

const useLoginExperimentEventProps = (props = {}) => {
  const source = props.source || 'drawer';
  const isLoginModalVariation = useLoginStore(getIsLoginModalVariation);
  const IsLoginModalExperiment = useLoginStore(getIsLoginModalExperiment);
  const IsNewLoginModal = useLoginStore(getIsNewLoginModal);
  const isTTU = source === LOGIN_SOURCE_TTU;
  const experimentData = {
    [EXPERIMENT_ID]: LOGIN_MODAL_EXPERIMENT_ID,
    [EXPERIMENT_NAME]: LOGIN_MODAL_EXPERIMENT,
    [VARIATION_NAME]: isLoginModalVariation,
    [CURTAIN_TYPE]:
      IsLoginModalExperiment && IsNewLoginModal && !isTTU
        ? 'modal'
        : 'side_curtain'
  };
  return experimentData;
};

export default useLoginExperimentEventProps;
